import React, { Component } from 'react'
import { HashRouter, Route, Link } from 'react-router-dom'
import styled from 'styled-components'

import en from './l10n/en.json'
import th from './l10n/th.json'

import { getLangSlug, setLangSlug } from './services/appServices'
import { checkInit, getAppConfig } from './services/apiServices'
import LoadingModal from './commons/Modal/Loading'

import HomePage from './components/Home/Home'
import ActivatePage from './components/Activate/Activate'
import StarterTemplatesPage from './components/StarterTemplates/StarterTemplates'
import TonePage from './components/Tone/Tone'
import HeaderGeneralPage from './components/Header/HeaderGeneral/HeaderGeneral'
import HeaderMainMenuPage from './components/Header/HeaderMainMenu/HeaderMainMenu'
import FooterPage from './components/Footer/Footer'
import ColumnPage from './components/Column/Column'
import ProductGeneralPage from './components/Product/ProductGeneral/ProductGeneral'
import CategoryBannerPage from './components/Product/CategoryBanner/CategoryBanner'
import ArticleGeneralPage from './components/Article/ArticleGeneral/ArticleGeneral'
import AdditionalCssPage from './components/AdditionalCss/AdditionalCss'
import ThemeUpdatePage from './components/ThemeUpdate/ThemeUpdate'

import {
    FontColorsOutlined,
    BgColorsOutlined,
    VerticalAlignTopOutlined,
    VerticalAlignBottomOutlined,
    LayoutOutlined,
    ShoppingCartOutlined,
    ReadOutlined,
    SyncOutlined,
    AppstoreAddOutlined
} from '@ant-design/icons'

import './App.css'
import './Animate.css'
import 'antd/dist/antd.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/dracula.css'
import 'codemirror/mode/css/css'
import 'codemirror/mode/htmlmixed/htmlmixed'
import { Layout, Menu, Button, PageHeader } from 'antd'
const { Header, Content, Sider } = Layout
const { SubMenu } = Menu

const Title = styled(PageHeader)`
    .ant-page-header-heading-title,
    .ant-page-header-back-button {
        color: #fff !important;
    }
`

const HeaderBar = styled(Header)`
    background: #fff !important;
    padding-right: 20px !important;
    text-align: right;
`

class App extends Component {
    state = {
        hash: '',
        langSlug: 'en',
        isLoading: false
    }

    componentDidMount() {
        this.setCurrentPath()
        this.checkInit()
    }

    async checkInit() {
        this.setState({ isLoading: true });
        try {
            await checkInit();
            this.setState({ isLoading: false });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    setCurrentPath() {
        let { hash } = window.location
        hash = hash.split('?')[0]
        hash = hash.split('/')[1]
        this.setState({
            hash: hash || 'home',
            langSlug: getLangSlug()
        })
    }

    T(key, params) {
        let text = this.state.langSlug == 'en' ? en[key] : th[key]
        if (text && params) {
            text = this.replaceParams(text, params)
        }
        return text || key
    }

    replaceParams(text, params) {
        Object.keys(params).forEach(key => {
            let regExp = new RegExp(`({{${key}}})`, 'ig')
            text = text.replace(regExp, params[key])
        })
        return text
    }

    onChangeLangSlug(langSlug = 'en') {
        setLangSlug(langSlug)
        this.setState({ langSlug })
    }

    render() {
        return (
            <HashRouter>
                <Layout style={{ height: '100vh' }}>
                    <Sider
                        width={250}
                        breakpoint="lg"
                        collapsedWidth="0"
                        onBreakpoint={broken => {}}
                        onCollapse={(collapsed, type) => {}}>
                        <a href={window.config.rootUrl}>
                            <Title
                                className="site-page-header"
                                onBack={() => null}
                                title={this.T('BACK_TO_SITE')}
                            />
                        </a>
                        <Menu
                            theme="dark"
                            mode="inline"
                            selectedKeys={[this.state.hash]}>
                            <Menu.Item
                                key="starter-templates"
                                icon={<LayoutOutlined />}
                                onClick={() => this.setCurrentPath()}>
                                <Link to="/starter-templates">
                                    <span className="nav-text">
                                        {this.T('STARTER_TEMPLATES')}
                                    </span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key="tone"
                                icon={<FontColorsOutlined />}
                                onClick={() => this.setCurrentPath()}>
                                <Link to="/tone">
                                    <span className="nav-text">
                                        {this.T('LOGO_TONE')}
                                    </span>
                                </Link>
                            </Menu.Item>
                            <SubMenu
                                key="header"
                                icon={<VerticalAlignTopOutlined />}
                                title={this.T('HEADER')}>
                                <Menu.Item
                                    key="header-general"
                                    onClick={() => this.setCurrentPath()}>
                                    <Link to="/header-general">
                                        {this.T('GENERAL')}
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    key="header-main-menu"
                                    onClick={() => this.setCurrentPath()}>
                                    <Link to="/header-main-menu">
                                        {this.T('MAIN_MENU')}
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    key="header-category-menu"
                                    onClick={() => this.setCurrentPath()}>
                                    <Link to="/header-category-menu">
                                        {this.T('CATEGORIES_MENU')}
                                    </Link>
                                </Menu.Item>
                            </SubMenu>
                            <Menu.Item
                                key="footer"
                                icon={<VerticalAlignBottomOutlined />}
                                onClick={() => this.setCurrentPath()}>
                                <Link to="/footer">
                                    <span className="nav-text">
                                        {this.T('FOOTER')}
                                    </span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key="column"
                                icon={<AppstoreAddOutlined />}
                                onClick={() => this.setCurrentPath()}>
                                <Link to="/column">
                                    <span className="nav-text">
                                        {this.T('COLUMN')}
                                    </span>
                                </Link>
                            </Menu.Item>
                            <SubMenu
                                key="product"
                                icon={<ShoppingCartOutlined />}
                                title={this.T('PRODUCT')}>
                                <Menu.Item
                                    key="product-general"
                                    onClick={() => this.setCurrentPath()}>
                                    <Link to="/product-general">
                                        {this.T('GENERAL')}
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    key="product-category-banner"
                                    onClick={() => this.setCurrentPath()}>
                                    <Link to="/product-category-banner">
                                        {this.T('CATEGORY_BANNER')}
                                    </Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu
                                key="article"
                                icon={<ReadOutlined />}
                                title={this.T('ARTICLE')}>
                                <Menu.Item
                                    key="article-general"
                                    onClick={() => this.setCurrentPath()}>
                                    <Link to="/article-general">
                                        {this.T('GENERAL')}
                                    </Link>
                                </Menu.Item>
                                <Menu.Item
                                    key="article-category-banner"
                                    onClick={() => this.setCurrentPath()}>
                                    <Link to="/article-category-banner">
                                        {this.T('CATEGORY_BANNER')}
                                    </Link>
                                </Menu.Item>
                            </SubMenu>
                            <Menu.Item
                                key="additional-css"
                                icon={<BgColorsOutlined />}
                                onClick={() => this.setCurrentPath()}>
                                <Link to="/additional-css">
                                    <span className="nav-text">
                                        {this.T('ADDITIONAL_CSS')}
                                    </span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key="theme-update"
                                icon={<SyncOutlined />}
                                onClick={() => this.setCurrentPath()}>
                                <Link to="/theme-update">
                                    <span className="nav-text">
                                        {this.T('THEME_UPDATE')}
                                    </span>
                                </Link>
                            </Menu.Item>
                        </Menu>
                    </Sider>
                    <Layout className="layount-content">
                        <HeaderBar>
                            <Button.Group>
                                <Button
                                    type={
                                        this.state.langSlug == 'th'
                                            ? 'primary'
                                            : 'default'
                                    }
                                    onClick={() => this.onChangeLangSlug('th')}>
                                    ไทย
                                </Button>
                                <Button
                                    type={
                                        this.state.langSlug == 'en'
                                            ? 'primary'
                                            : 'default'
                                    }
                                    onClick={() => this.onChangeLangSlug('en')}>
                                    English
                                </Button>
                            </Button.Group>
                        </HeaderBar>
                        <Content style={{ margin: '24px 16px' }}>
                            {!this.state.isLoading && (
                                <div
                                    style={{
                                        marginBottom: 24
                                    }}>
                                    <Route
                                        path="/"
                                        exact
                                        component={() => (
                                            <HomePage T={this.T.bind(this)} />
                                        )}
                                    />
                                    <Route
                                        path="/activate"
                                        component={() => (
                                            <ActivatePage
                                                T={this.T.bind(this)}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/starter-templates"
                                        component={() => (
                                            <StarterTemplatesPage
                                                T={this.T.bind(this)}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/tone"
                                        exact
                                        component={() => (
                                            <TonePage T={this.T.bind(this)} />
                                        )}
                                    />
                                    <Route
                                        path="/header-general"
                                        exact
                                        component={() => (
                                            <HeaderGeneralPage
                                                T={this.T.bind(this)}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/header-main-menu"
                                        exact
                                        component={() => (
                                            <HeaderMainMenuPage
                                                T={this.T.bind(this)}
                                                type="MAIN"
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/header-category-menu"
                                        exact
                                        component={() => (
                                            <HeaderMainMenuPage
                                                T={this.T.bind(this)}
                                                type="CATEGORY"
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/footer"
                                        exact
                                        component={() => (
                                            <FooterPage T={this.T.bind(this)} />
                                        )}
                                    />
                                    <Route
                                        path="/column"
                                        exact
                                        component={() => (
                                            <ColumnPage T={this.T.bind(this)} />
                                        )}
                                    />
                                    <Route
                                        path="/product-general"
                                        exact
                                        component={() => (
                                            <ProductGeneralPage
                                                T={this.T.bind(this)}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/product-category-banner"
                                        exact
                                        component={() => (
                                            <CategoryBannerPage
                                                T={this.T.bind(this)}
                                                type="PRODUCT"
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/article-category-banner"
                                        exact
                                        component={() => (
                                            <CategoryBannerPage
                                                T={this.T.bind(this)}
                                                type="ARTICLE"
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/article-general"
                                        exact
                                        component={() => (
                                            <ArticleGeneralPage
                                                T={this.T.bind(this)}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/additional-css"
                                        exact
                                        component={() => (
                                            <AdditionalCssPage
                                                T={this.T.bind(this)}
                                                langSlug={this.state.langSlug}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/theme-update"
                                        exact
                                        component={() => (
                                            <ThemeUpdatePage
                                                T={this.T.bind(this)}
                                                langSlug={this.state.langSlug}
                                            />
                                        )}
                                    />
                                </div>
                            )}
                        </Content>
                    </Layout>
                    <LoadingModal isOpen={this.state.isLoading} />
                </Layout>
            </HashRouter>
        )
    }
}

export default App
